import { ContactsTypesTypes } from './contacts-types';

export interface IContactRequest {
  customerId?: number;
  jobsiteId?: number;
  contactType?: ContactsTypesTypes[];
}
